import React, { useContext, useRef } from "react";

import { ReasonKinds } from "@featbit/js-client-sdk";

import { FeatureFlagContext, Navigate, Outlet, getActiveToken, isFeatureFlagsEnabled, useFeatureFlag, useUserContext } from "utils";

import { FEATURE_FLAGS } from "consts";

// These routes stay in the tree. Unmounting them makes /scenarios fall through to the app error page.
export const SoilSightRouteGate = () => {
  const { isEnabled, kind, isForced } = useFeatureFlag(FEATURE_FLAGS.SOIL_SIGHT_INTEGRATION);
  const { identifiedKeyId, identifying } = useContext(FeatureFlagContext);
  const { user } = useUserContext();
  // the user the flag last let through: after a farm switch FeatBit identifies them again and answers from an empty store
  const allowedUserId = useRef<string | null>(null);

  // Right after sign-in the flags still answer for the anonymous visitor, so we wait until FeatBit knows this user.
  const token = getActiveToken();
  const awaitingIdentity = !!token && token !== "null" && (!user?.id || identifiedKeyId !== user.id);

  // An env-disabled SDK stays ClientNotReady forever, so we wait on the flag only when the SDK can answer; a forced flag never waits.
  const resolving = !isForced && (kind === ReasonKinds.ClientNotReady || awaitingIdentity || identifying) && isFeatureFlagsEnabled();

  if (!resolving) allowedUserId.current = isEnabled && user?.id ? user.id : null;
  if (resolving) return user?.id && allowedUserId.current === user.id ? <Outlet /> : null;

  if (!isEnabled) return <Navigate to="/home" replace />;

  return <Outlet />;
};
